var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"SkeletonBox",style:({
      height: _vm.height,
      width: _vm.computedWidth,
      padding: _vm.padding,
      marginBottom: _vm.marginBottom,
      marginTop: _vm.marginTop,
      marginLeft: _vm.marginLeft
    })}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }